/******************************************************************************
 * [googleanalytics]
 *
 * 목 적 :
 * 설 명 :
 * 진 행 :
 * 주 의 :
 * 이 슈 :
 * 일 자 :
 * 작 성 :
 * 참 조 :
 *
 *****************************************************************************/

// Original
// <!-- Global site tag (gtag.js) - Google Analytics -->
// <script async src="https://www.googletagmanager.com/gtag/js?id=UA-127600289-1"></script>
// <script>
// window.dataLayer = window.dataLayer || [];
// function gtag(){dataLayer.push(arguments);}
// gtag('js', new Date());
//
// gtag('config', 'UA-127600289-1');
// </script>


// function gtag(){dataLayer.push(arguments);}
//
// function gaInit(){
//   window.dataLayer = window.dataLayer || [];
//   gtag('js', new Date());
//   gtag('config', 'UA-127600289-1');
// }
// return new Promise((resolve, reject) => {
//   let script = document.createElement('script');
//   script.onload = () => {
//     resolve(import(gaInit))
//   };
//   script.async = true;
//   script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-127600289-1';
//     document.head.appendChild(script)
// })

export function gaScript()  {
  var d = document,
    s = 'script',
    id = 'ga-script',
    js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return
  }
  js = d.createElement(s);
  js.id = id;
  fjs.parentNode.insertBefore(js, fjs);
  js.onload = function () {

    function gaInit() {
      // if (window.YT.loaded) {
      //   cb();
      // } else {
      //   setTimeout(() => {
      //     checkYTLoaded(cb);
      //   }, 1000)
      // }
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-127600289-1');
    };
    gaInit();
  };
  js.async = true;
  js.src = 'https://www.googletagmanager.com/gtag/js?id=UA-127600289-1';
};




//////////////////
// WEBPACK FOOTER
// ./static/assets/js/utility/googleanalytics-ie10.js
// module id = u2iR
// module chunks = 4